module.exports = __webpack_public_path__ + "img/bookshelf.a6f262ac.png";